import {
  ErrorClassification,
  NetworkErrorCategory,
  PaymentStep,
} from "./exception-logger"

type ApiRule =
  | { category: "payment"; step: PaymentStep }
  | { category: Exclude<NetworkErrorCategory, "payment"> }

// Ordered — first match wins, so specific patterns must come before the
// broader ones (e.g. /orders/{id}/payment-methods is payment, not order)
const RULES: Array<[RegExp, ApiRule]> = [
  [/\/credit-cards|\/ps\//, { category: "payment", step: "add-card" }],
  [/\/cancel(\/|$)/, { category: "payment", step: "cancel-payment" }],
  [
    /\/pay(\/|$)|\/payment-methods/,
    { category: "payment", step: "initiate-payment" },
  ],
  // Adyen/Stripe post the 3DS result back to a payment-details link
  [/\/details(\/|$)/, { category: "payment", step: "sca-challenge" }],
  // Any other payment sub-resource is a status/detail lookup
  [/\/payments?(\/|$)/, { category: "payment", step: "status-polling" }],
  [/\/product-labels/, { category: "product-labels" }],
  [/\/recommended-products|\/products/, { category: "products" }],
  [/\/orders|\/active-orders/, { category: "order" }],
  [/\/shops|\/venues/, { category: "venues" }],
  [/\/me(\/|$)|\/addresses|\/terms/, { category: "user" }],
  [
    /\/auth|\/signup|\/signout|\/password-recovery|\/email_confirm|\/email_verify/,
    { category: "auth" },
  ],
]

/** Strips the query string so tokens and search params never reach logging */
export const toEndpoint = (url: string): string => url.split("?")[0]

// Everything routed through our fetch layer goes to the drinks backend, so
// the target is always internal - third-party SDK calls never come through
// here and classify themselves as "external-api" at the call site.
export const classifyApiUrl = (url: string): ErrorClassification => {
  const path = toEndpoint(url)
  const match = RULES.find(([pattern]) => pattern.test(path))
  const rule: ApiRule = match ? match[1] : { category: "unknown" }
  return { type: "network", target: "internal-api", ...rule }
}
